import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  searchField: {
    width: 376,
  },
  tags: {
    marginTop: 16,
    '& > div': {
      marginRight: 16,
      marginBottom: 8,
      maxWidth: '100%',
      '& > span': {
        '& > p': {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
      },
    },
  },
});
